/**
 * Gestion ouverture du 'mini-panier' au clic et au hover
 */
function bindMiniCart() {
    const $miniCart = $('.mini-cart');
    const $miniCartArrow = $miniCart.find('.mini-cart__arrow');

    if($miniCart.length && $miniCartArrow.length) {
        $miniCart.on('mouseenter', function() {
            $miniCart.addClass('mini-cart--opened');
        });
        $miniCart.on('mouseleave', function() {
            $miniCart.removeClass('mini-cart--opened');
        });
        $miniCartArrow.on('click', function() {
            $miniCart.toggleClass('mini-cart--opened');
        });
    }
}

function unbindMiniCart() {
    const $miniCart = $('.mini-cart');
    const $miniCartArrow = $miniCart.find('.mini-cart__arrow');

    if($miniCart.length && $miniCartArrow.length) {
        $miniCart.off('mouseenter');
        $miniCart.off('mouseleave');
        $miniCartArrow.off('click');
    }
}
if(document.readyState !== 'loading') {
    bindMiniCart();
}
else {
    window.addEventListener('DOMContentLoaded', bindMiniCart);
}

/**
 * Recalcul du mini-panier
 */
function refreshMiniCart(callback = null) {
    $.ajax({
            url: ajaxurl,
            data: {
                action: 'refreshMiniCart',

            },
            beforeSend: function () {
                $('#cart').empty();
                // LOADER !
            }
        })
        .done(function (data) {
            unbindMiniCart();
            
            $('#cart').replaceWith(data);

            bindMiniCart();
            
            if(callback) {
                callback();
            }
        })
        .fail(function (data) {
            console.error('fail', data);
        });
}
window.refreshMiniCart = refreshMiniCart;

/**
 * Formatteur de monnaie
 */
function money(value) {
    return value.toLocaleString('fr-FR', {
        style: 'currency',
        currency: 'EUR'
    }) + '&nbsp;HT';
}
window.money = money;

/**
 * Listeners sur la page panier uniquement
 */
if ($('.page-template-panier').length) {
    function refreshTotal() {
        $.get(ajaxurl, {
            action: 'cartTotal'
        })
        .done(function (data) {
            $('#total-number').html(money(data.total));
            $('.itemsInCart').text(data.itemsInCart > 0 ? data.itemsInCart : '');

            // Si le montant du panier vaut 0, on retire la possibilité de finaliser sa commande
            if(data.total === 0) {
                $('#cart-validate-action')
                    .attr('href', '#')
                    .addClass('button--disabled');
            }
        });
    }
    function refreshRecruitmentTotal(recruitmentId) {
        const $cartItem = $(`#recruitment-${recruitmentId}`);

        $cartItem.addClass('cart-item--busy');

        $.post(ajaxurl, {
            action: 'cartRecruitmentTotal',
            recruitment: recruitmentId
        })
        .done(function (data) {
            const $cartItemSubTotal = $(`#recruitment-${recruitmentId} .cart-item__sub-total`);
            
            if($cartItemSubTotal.length) {
                $cartItemSubTotal.html(money(data.total));
            }

            $cartItem.removeClass('cart-item--busy');
        });
    }

    /**
     * Suppression d'un recrutement
     */
    $('.recruitment-delete').on('click', function () {
        const $this = $(this);
        const recruitmentId = $this.data('id');
        const $cartItem = $(`#recruitment-${recruitmentId}`);

        $.post(ajaxurl, {
            action: 'cartDeleteRecruitment',
            recruitment: recruitmentId
        }).done(function (data) {
            if (data.status) {
                $cartItem.fadeOut(function () {
                    $(this).remove();
                });

                refreshTotal();
            }
        });
    });

    /**
     * Suppression d'une offre
     */
    $('.offer-delete').on('click', function () {
        const $this = $(this);
        const offerId = $this.data('id');
        const recruitmentId = $this.data('recruitment-id');
        const $cartItem = $this.parents('.cart-item');

        $cartItem.addClass('cart-item--busy');

        $.post(ajaxurl, {
            action: 'cartDeleteOffer',
            offer: offerId
        }).done(function (data) {
            if (data.status) {
                $this.parents('li').fadeOut(function () {
                    $(this).remove();
                    $cartItem.removeClass('cart-item--busy');
                });

                refreshRecruitmentTotal(recruitmentId);
                refreshTotal();
            }
        });
    });

    /**
     * Suppression d'une option
     */
    $('.option-delete').on('click', function () {
        const $this = $(this);
        const optionId = $this.data('id');
        const recruitmentId = $this.data('recruitment-id');
        const $cartItem = $this.parents('.cart-item');

        $cartItem.addClass('cart-item--busy');

        $.post(ajaxurl, {
            action: 'cartDeleteOption',
            option: optionId
        }).done(function (data) {
            if (data.status) {
                $this.parents('.option').fadeOut(function () {
                    $(this).remove();
                    $cartItem.removeClass('cart-item--busy');
                });

                refreshRecruitmentTotal(recruitmentId);
                refreshTotal();
            }
        });
    });


    /**
     * Gestion affichage/masquage de la description des options au sein du panier (sur mobile/tablette)
     */
    $('.cart-item__support-option-name, .cart-item__support-option-price').on('click', function (e) {
        const $target = $(e.target);
        const $option = $target.parents('.cart-item__support-option');
        
        if($option.length) {
            const $optionDescription = $option.find('.cart-item__support-option-description');
            
            if($optionDescription.length) {
                $optionDescription.toggleClass('hidden');
            }
        }
    });
}